import { render, staticRenderFns } from "./input-img-hall.vue?vue&type=template&id=00279124&"
import script from "./input-img-hall.vue?vue&type=script&lang=js&"
export * from "./input-img-hall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports